import { render, staticRenderFns } from "./LoyaltyReport.vue?vue&type=template&id=50212c83&scoped=true&"
import script from "./LoyaltyReport.vue?vue&type=script&lang=js&"
export * from "./LoyaltyReport.vue?vue&type=script&lang=js&"
import style0 from "./LoyaltyReport.vue?vue&type=style&index=0&id=50212c83&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50212c83",
  null
  
)

export default component.exports